import React from "react";

import { TokenImpersonationIndicator } from "src/adminPanel/users/TokenImpersonationIndicator";
import { WebchatButton } from "src/base-components/WebchatButton";
import { Router } from "src/router/Router";

export const App: React.FC = () => {
  return (
    <div className="flex h-screen w-screen flex-col overflow-clip">
      <Router />
      {/*
        Outside the router on purpose: the impersonation rides the session
        token, not a route, so the indicator must survive every navigation.
      */}
      <TokenImpersonationIndicator />
      <WebchatButton />
    </div>
  );
};
